var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207 193",
    width: 500,
    height: 466,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #002d53 } \n\t\t.s1 { fill: none;stroke: #000000;stroke-width: 3 } \n\t\t.s2 { fill: none;stroke: #000000;stroke-linejoin: bevel;stroke-width: 3 } \n\t\t.s3 { fill: #ffffff } \n\t\t.s4 { fill: #ffffff;stroke: #000000;stroke-width: 3 } \n\t\t.s5 { fill: none;stroke: #000000;stroke-miterlimit:10;stroke-width: 3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m81.2 180.9c0.8 11.6 14.2 9.7 22.2 9.8 8.2 0.1 22.3 2.1 22.5-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m81.2 180.9c0.8 11.6 14.2 9.7 22.2 9.8 8.2 0.1 22.3 2.1 22.5-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m59 117h-0.5c5.7 6.8 9.8 21.3 11.9 30.2h65.6c2.1-8.7 6.1-23 11.6-29.7 13.6-12.2 22.2-29.8 22.2-49.5 0-36.6-29.6-66.3-66.2-66.3-36.6 0-66.3 29.7-66.3 66.3 0 19.4 8.3 36.9 21.7 49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m138.8 150.3c0 2.5-1.9 4.4-4.3 4.4h-61.9c-2.4 0-4.3-1.9-4.3-4.4 0-2.4 1.9-4.3 4.3-4.3h61.9c2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m138.8 161.3c0 2.4-1.9 4.4-4.3 4.4h-61.9c-2.4 0-4.3-2-4.3-4.4 0-2.4 1.9-4.4 4.3-4.4h61.9c2.4 0 4.3 2 4.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m138.8 172.3c0 2.4-1.9 4.4-4.3 4.4h-61.9c-2.4 0-4.3-2-4.3-4.4 0-2.4 1.9-4.4 4.3-4.4h61.9c2.4 0 4.3 2 4.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m103.6 21.5c-46.5 0-86.1 22.7-101.9 54.8 15.8 32.1 55.4 54.9 101.9 54.9 46.4 0 86.1-22.8 101.8-54.9-15.7-32.1-55.4-54.8-101.8-54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m52 76.3c0-28.4 23.1-51.5 51.5-51.5 28.5 0 51.6 23.1 51.6 51.5 0 28.5-23.1 51.6-51.6 51.6-28.4 0-51.5-23.1-51.5-51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m103.6 21.5c-46.5 0-86.1 22.7-101.9 54.8 15.8 32.1 55.4 54.9 101.9 54.9 46.4 0 86.1-22.8 101.8-54.9-15.7-32.1-55.4-54.8-101.8-54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m153.8 31.2c-14.1-4.4-28-7.8-44.2-7-46.4 2.1-86.5 28.2-100.7 61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m118.1 51.7l-14.5 24.6v-28.5c-15.8 0-28.6 12.7-28.6 28.5 0 15.8 12.8 28.6 28.6 28.6 15.7 0 28.5-12.8 28.5-28.6 0-10.5-5.6-19.6-14-24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m121.8 107.9c-17.5 10-39.7 4.1-49.8-13.4-10-17.4-4.1-39.7 13.3-49.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m131.9 99.2q-2.1 2.6-4.7 4.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.75c8cc3cc491d19a6130831aa848591c.svg";
export { ForwardRef as ReactComponent };